import { safeGet } from '../../core/utils/safe-get.js';
import type { AxisIdToScales } from '../context/XYChartScales.context.js';
import { BAR_VARIANT } from '../types/xy-chart-internals.js';

export function getCurrentScale(
  axisIdToScales: AxisIdToScales,
  axisId: string,
  seriesType?: string,
) {
  const scales = safeGet(axisIdToScales, axisId);
  return seriesType === BAR_VARIANT && scales.categoricalBarScale
    ? scales.categoricalBarScale
    : scales.currentScale;
}

export function getInitialScale(
  axisIdToScales: AxisIdToScales,
  axisId: string,
) {
  return safeGet(axisIdToScales, axisId).initialScale;
}

export function getDimensionScale(
  axisIdToScales: AxisIdToScales,
  axisId: string,
) {
  return safeGet(axisIdToScales, axisId).dimensionScale;
}
